/**
 * StaffDeleteRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffDeleteRes
 */
export interface StaffDeleteRes {
  /** 删除成功 */
  success?: boolean
}

/**
 * StaffDeleteRes Schema
 */
export const StaffDeleteResSchema: SchemaDefinition = {
  properties: {
    success: {
      description: '删除成功',
      format: 'bool',
      type: 'boolean',
      label: '删除成功',
    },
  },
  type: 'object',
}
